<div class="page-content mt-3 mt-md-4">
  <ng-content></ng-content>
</div>
